import _extends from "@babel/runtime/helpers/esm/extends";
import { internalDateLocale } from "../../../../../lib/date/localeSets";
import { LangCodes } from "../../../../../lib/locale";
import { componentsLocales as CalendarLocales } from "../../../../Calendar/locale/locales/ru";
import { componentsLocales as DateSelectLocales } from "../../../../../internal/DateSelect/locale/locales/ru";
export var componentsLocales = _extends({
  today: 'Сегодня',
  todayAriaLabel: 'Перейти к сегодняшней дате'
}, CalendarLocales, DateSelectLocales, internalDateLocale[LangCodes.ru_RU]);